module.exports = __webpack_public_path__ + "asset/img/banner.8a4f9970.jpg";